
define('ldsh!modules/form_editor/templates/preview_custom_date', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if(labelVisible) { ;
__p += '\n<label class="control-label col-sm-3" for="">' +
((__t = ( labelText )) == null ? '' : __t) +
'</label>\n';
 } ;
__p += '\n<div class="col-sm-9 js-control">\n    <input hidden class="js-custom-date ' +
((__t = ( isRequired ? 'form-element-required': '' )) == null ? '' : __t) +
'"\n           name="' +
((__t = ( nameAttr )) == null ? '' : __t) +
'"\n           value=""\n           data-separator="' +
((__t = ( separator )) == null ? '' : __t) +
'"\n           data-invalid-date-message="' +
((__t = ( invalidDateMessage )) == null ? '' : __t) +
'"\n           data-invalid-date-agelimit-message="' +
((__t = ( invalidDateAgeLimitMessage )) == null ? '' : __t) +
'"\n           data-agelimit="' +
((__t = ( ageLimit )) == null ? '' : __t) +
'"\n           id="' +
((__t = ( elementId )) == null ? '' : __t) +
'"\n    />\n  ';
 for(var i=0; i<3; i++) { ;
__p += '\n  <div class="date-cell date-cell-' +
((__t = ( itemSuffix[i] )) == null ? '' : __t) +
'">\n    <select class="form-control js-select-' +
((__t = (i)) == null ? '' : __t) +
'" id="' +
((__t = ( elementId + '-' + itemSuffix[i] )) == null ? '' : __t) +
'"></select>\n  </div>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

